import { Box } from "@chakra-ui/react";
import { baseColors, BaseStack } from "goi_common/src/design-system";

interface Props {
  remainingMs: number;
}

export function FomoCountdownInlineBanner({ remainingMs }: Props) {
  const minutes = String(Math.floor(remainingMs / 60000)).padStart(2, "0");
  const seconds = String(Math.floor((remainingMs / 1000) % 60)).padStart(
    2,
    "0"
  );

  return (
    <Box
      width="calc(100% - 32px)"
      maxWidth="440px"
      mx="auto"
      background={baseColors.label_normal}
      borderRadius="12px"
      px="12px"
      py="8px"
      display="flex"
      alignItems="center"
    >
      <BaseStack
        direction="horizontal"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <BaseStack spacing={2} direction="horizontal">
          <Box
            className="body_1_normal_sb"
            color={baseColors.red_300}
            whiteSpace="nowrap"
          >
            10만원 추가 할인
          </Box>
          <Box
            className="body_1_normal_sb"
            color={baseColors.white}
            whiteSpace="nowrap"
          >
            이벤트 마감까지
          </Box>
        </BaseStack>

        <BaseStack direction="horizontal" spacing={4} alignItems="flex-start">
          <BaseStack spacing={2} alignItems="center">
            <Box
              background={baseColors.red_150}
              borderRadius="4px"
              px="2px"
              py="2px"
              minWidth="28px"
              textAlign="center"
              className="body_1_normal_sb"
              color={baseColors.status_negative}
            >
              {minutes}
            </Box>
          </BaseStack>

          <Box
            className="body_1_normal_sb"
            color={baseColors.label_assistive_1}
          >
            :
          </Box>

          <BaseStack spacing={2} alignItems="center">
            <Box
              background={baseColors.red_150}
              borderRadius="4px"
              px="2px"
              py="2px"
              minWidth="28px"
              textAlign="center"
              className="body_1_normal_sb"
              color={baseColors.status_negative}
            >
              {seconds}
            </Box>
          </BaseStack>
        </BaseStack>
      </BaseStack>
    </Box>
  );
}
